import styled from "styled-components";
import { Heading } from "@pepdirect/v3/ui/Heading";
import { Device } from "@pepdirect/v3/styles/screenSizes";
import { Spinner } from "@pepdirect/v3/ui/Spinner";

export const StyledAddButton = styled.div`
  margin-bottom: 40px;
  span {
    margin-left: 8px;
  }
`;

export const StyledCheckboxContainer = styled.div`
  margin-top: 10px;
  width: 100%;
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
`;

export const StyledLabel = styled.label`
  display: flex;
  width: 100%;
  min-height: 20px;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 10px;

  div:first-child {
    margin-right: 11px;
  }
`;

export const StyledNewPaymentForm = styled.div`
  margin-bottom: 40px;
`;

export const StyledPaymentTypeSelector = styled.div`
  padding-bottom: 20px;

  @media ${Device.laptop} {
    max-width: 340px;
  }
`;

export const StyledSavedPaymentMethods = styled.div`
  margin: 16px 0;
`;

export const StyledSpinner = styled(Spinner)`
  margin-top: 60px;
`;

export const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
`;

export const StyledCoversFullAmount = styled.div`
  margin-bottom: 16px;
`;
